const hostname = window.location.hostname

const microApps = [
  {
    name: 'subDelivery',
    entry: process.env.NODE_ENV === 'production'?`//${hostname}/subapp/subDelivery/`:`//${hostname}:7778/subapp/subDelivery/`,
    activeRule: '/subDelivery',
  },
]

const apps = microApps.map(item => {
  return {
    ...item,
    container: '#subapp-viewport', // 子应用挂载的div
    props: {
      routerBase: item.activeRule, // 下发基础路由
    }
  }
})
export default apps



// WEBPACK FOOTER //
// ./src/micro-app.js